import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect } from "react";
import { FormField } from "./form-field";
export default function SingleChildLocation(props) {
    const { location, value, onChange, setHasChildLocations, filterRegionsText } = props;
    const handleCheckboxChange = useCallback((checkedValue) => {
        if (checkedValue === "on") {
            onChange([...value.split(","), location.slug].join(","));
        }
        else {
            let newArray = value.split(",");
            newArray = newArray.filter((item) => item.localeCompare(location.slug) ? location.slug : null);
            onChange(newArray.join(","));
        }
    }, [onChange]);
    useEffect(() => {
        setHasChildLocations(!(location.search && filterRegionsText && !location.search.includes(filterRegionsText.toLowerCase())));
    }, []);
    if (location.search && filterRegionsText && !location.search.includes(filterRegionsText.toLowerCase())) {
        return _jsx(_Fragment, {});
    }
    return (_jsx(_Fragment, { children: _jsxs("div", { className: "flex items-center", children: [_jsx("span", { className: "location-dropdown-trigger flex-grow ml-1 cursor-pointer", children: location.name }), _jsx(FormField, { type: "checkbox", value: location.slug, onChange: handleCheckboxChange, label: "", placeholder: "-", className: "range-dropdown-input", checked: value.split(",").includes(location.slug) })] }) }));
}
